import { useQuery } from '@tanstack/react-query'
import { getJahisMasterPresets } from '../../../../apis/jahisMaster'
import { queryKeys } from '../../../../shared'

/**
 * 用法マスタプリセット一覧 Query hook
 */
export const useJahisMasterPresetsQuery = () => {
  return useQuery({
    queryKey: queryKeys.jahisMaster.presets(),
    queryFn: getJahisMasterPresets,
  })
}
